module.exports = __webpack_public_path__ + "img/attach.93c96192.svg";